import moment from 'moment';
import React from 'react';
import { Modal, Button, Accordion, Table, Badge } from 'react-bootstrap';

const LabRequestHistoryModal = ({ show, onClose, data }) => {
    console.log(data)
  

  return (
    <Modal show={show} onHide={onClose} centered size="">
      <Modal.Header closeButton>
        <Modal.Title>Lab Request History</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Appointment Details */}
        <div className={"divider divider-start fw-medium"}>
            <span>Lab Request History Details</span>
        </div>
        <div className='d-flex align-items-cente gap-2'>
            <strong>Date:</strong>
            <div className="mb-0 d-flex gap-2 align-items-cente">
                <label className="d-block text-primary fs-sm mb-1">{moment(data?.createdAt).format("D MMM, YYYY")}</label>
                <h6>{moment(data?.createdAt).format("dddd, h:mm A")}</h6>
            </div>
        </div>
        <p className='mb-2'><strong>Lab Investigation:</strong> {data?.item?.labTest?.name ?? "---"}</p>
        <p className='mb-2'><strong>Approved By:</strong><span className='text-primary text-capitalize'> {data?.item?.approvedBy?? "---"}</span></p>
        <p className='mb-2'><strong>Amount:</strong> {data?.item?.transaction?.amount.toLocaleString("en-NG", { style: "currency", currency: "NGN" })} <span className='text-danger'>({data?.item?.transaction?.description?? "---"})</span></p>
        <p className='mb-2'><strong>Bill Source:</strong><span className='text-primary text-capitalize'> {data?.item?.transaction?.bill_source?? "---"}</span></p>
        <p className='mb-2'><strong>Scheme:</strong><span className='text-primary'> {data?.patient?.hmo?.name ?? "---"}</span></p>
        <p className='mb-2'><strong>Request Type:</strong><span className='text-primary'> {data?.requestNote?? "---"}</span></p>
        <p className='mb-2'><strong>Request Note:</strong><span className='text-primary text-capitalize'> {data?.requestType?? "---"}</span></p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LabRequestHistoryModal;
